import $ from 'jquery';
import React from "react";
import _ from 'lodash';

import QuantityTextField from "./../quantityTextField";
import * as Misc from "./../../misc";
import ProjectScope from "./projectScope";
import StoneStore from "./../../stores/stonesStore";
import ActionTypes from "./../../actionTypes";
import IndividualFeatureItem from './individualFeatureItem';
import Analytics from './../../analytics';

export default class ProjectScopeFeatureContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getStateObject();
  }

  componentDidMount() {
    $(document).on(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteChanged);
  }

  componentWillUnmount() {
    $(document).off(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteChanged);
  }

  handleQuoteChanged = () => {
    this.setState(this.getStateObject());
  };

  getStateObject = () => {
    const features = StoneStore.featuresByGroupName(this.props.groupName, ProjectScope.quote());
    const mainFeature = _.head(features);
    const selectedFeatures = ProjectScope.selectedFeatures();
    const selectedFeaturesFromGroup = _.intersectionWith(features, selectedFeatures, (feat, id) => {
      return id === feat.id;
    });
    const scopeFeatures = ProjectScope.quote().features;

    let hideQuantity = false;
    let individual = false;
    let hideUnit = false;

    if(mainFeature) {
      _.forEach(mainFeature.flags || [], f => {
        if (f === 'u') {
          hideUnit = true;
        } else if (f.substring(0, 1) === 'q') {
          hideQuantity = true;
        } else if (f === 'i') {
          individual = true;
        }
      });
    }

    if (individual) {
      hideQuantity = true;
      hideUnit = true;
    }

    let value = 0;
    if (!hideQuantity && mainFeature) {
      value = ProjectScope.quote().features[mainFeature.id];
    }

    return {
      value: value,
      features: features,
      mainFeature: mainFeature,
      selectedFeatures: selectedFeatures,
      selectedFeaturesFromGroup: selectedFeaturesFromGroup,
      scopeFeatures: scopeFeatures,
      hideQuantity: hideQuantity,
      individual: individual,
      hideUnit: hideUnit
    };
  };

  handleValueChanged = (value) => {
    //this.setState({value: value});
    if (!this.state.hideQuantity) {
      const o = {};
      o[this.state.mainFeature.id] = value;
      ProjectScope.updateFeaturesQuantities([this.state.mainFeature.id], o);
      Analytics.sendDataEnteredEvent('selected-feature-changed: ' + this.props.groupName);
    }
  };

  handleSelectClick = (e) => {
    Analytics.sendClickEvent('show-feature-selection: ' + this.props.groupName);
    Misc.ignoreDefault(e);
    Misc.hideQQGirl();
    this.props.showFeatureSelection(this.props.groupName);
  };

  render() {
    let innerFeaturesElements = null;
    let replaceInnerContainer = false;
    let elements = null;
    if (!this.state.individual) {
      if (this.state.hideQuantity && _.size(this.state.selectedFeaturesFromGroup)) {
        replaceInnerContainer = true;

        elements = _.take(this.state.selectedFeaturesFromGroup, Math.min(3, this.state.selectedFeaturesFromGroup.length))
          .map((f) => {
            return (<IndividualFeatureItem feature={f} scopeFeatures={this.state.scopeFeatures} key={f.id}/>);
          });

        while (elements.length < 3) {
          elements.push((<div className="project-scope-selection-options-placeholders" key={'ph' + elements.length}/>));
        }

        let others = null;
        if (this.state.selectedFeaturesFromGroup.length > 3) {
          others = (<h2>{"...and " + (this.state.selectedFeaturesFromGroup.length - 3) + " other(s)"}</h2>);
        }

        innerFeaturesElements = (
          <div className="project-scope-selection-options-wrapper">
            {elements}
            {others}
          </div>
        );

      } else {
        //innerFeaturesElements = (<span>{StoneStore.featureGroupNameDescription(this.props.groupName)}</span>);
        innerFeaturesElements = (
          this.props.showbutton
            ? <div className="project-scope-button" onClick={this.handleSelectClick}>{elements ? "Edit" : "Select"}</div>
            : <span>{"No "+this.props.groupName.replace("Counter Top Removal", "Removal") + " selected"}</span>
        );
      }
    } else {
      if (_.size(this.state.selectedFeaturesFromGroup)) {
        replaceInnerContainer = true;
        elements = _.take(this.state.selectedFeaturesFromGroup, Math.min(3, this.state.selectedFeaturesFromGroup.length))
          .map((f) => {
            return (<IndividualFeatureItem feature={f} scopeFeatures={this.state.scopeFeatures} key={f.id}/>);
          });

        while (elements.length < 3) {
          elements.push((<div className="project-scope-selection-options-placeholders" key={'ph' + elements.length}/>));
        }

        let others = null;
        if (this.state.selectedFeaturesFromGroup.length > 3) {
          others = (<h2>{"...and " + (this.state.selectedFeaturesFromGroup.length - 3) + " other(s)"}</h2>);
        }

        innerFeaturesElements = (
          <div className="project-scope-selection-options-wrapper">
            {elements}
            {others}
          </div>
        );
      } else {
        innerFeaturesElements = (
          this.props.showbutton
            ? <div className="project-scope-button" onClick={this.handleSelectClick}>{elements ? "Edit" : "Select"}</div>
            : <span>{"No "+this.props.groupName.replace("Counter Top Removal", "Removal") + " selected"}</span>
        );
      }
    }

    let content = null;
    if (!replaceInnerContainer) {
      content = (<div className={"project-scope-blank-set-box" + (!this.state.hideQuantity ? '-form' : '') }>
        {innerFeaturesElements}
        {this.renderQuantityBox(this.state.hideQuantity)}
        {/*<p>{this.state.hideUnit ? '' : this.state.mainFeature.unit}</p> */}
      </div>);
    } else {
      content = innerFeaturesElements;
    }

    return (
      <div className="project-scope-box-content">
        {content}
      </div>);
  }

  renderQuantityBox = (hideQuantity) => {
    if (hideQuantity) {
      return null;
    }

    return (
      <QuantityTextField value={this.state.value} className="project-scope-textbox-form"
                         onBlur={this.handleValueChanged}/>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/projectScope/featureContent.js